import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  location: string;
  text: string;
  image?: string;
}
export function TestimonialCard({
  name,
  location,
  text,
  image
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-lg shadow-lg" data-id="element-102">
      <div className="flex gap-1 mb-4" data-id="element-103">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#D4AF37] text-[#D4AF37]" data-id="element-104" />)}
      </div>

      <p className="text-[#3A3226] leading-relaxed mb-6 italic" data-id="element-105">"{text}"</p>

      <div className="flex items-center gap-3" data-id="element-106">
        <div className="w-12 h-12 rounded-full bg-[#E8DCC4] flex items-center justify-center text-2xl" data-id="element-107">
          👤
        </div>
        <div data-id="element-108">
          <p className="font-semibold text-[#8B7355]" data-id="element-109">{name}</p>
          <p className="text-sm text-[#8B7355]/70" data-id="element-110">{location}</p>
        </div>
      </div>
    </div>;
}